import { useEffect } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import {
  changeConfigurationActiveComponent,
  changeHelpActiveComponent,
} from "../../configurationSlice";
import { changeCurrentProduct } from "../../../common/commonSlice";

export const PagaresHelp = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(changeConfigurationActiveComponent("Help"));
    dispatch(changeHelpActiveComponent("Documentacion Pagares"));
    dispatch(changeCurrentProduct("Ayuda y Documentacion"));
  }, []);
  return (
    <div
      style={{
        overflow: "auto",
        color: "white",
        padding: "2% 2%",
        width: "100%",
        height: "100%",
      }}
    >
      <h2
        style={{
          fontWeight: "bold",
          fontSize: "52px",
        }}
      >
        Pagarés
      </h2>
      <p>
        El servicio de Pagarés de anteia es una herramienta que permite la
        creación, firma, custodia y administración de pagarés.
      </p>
      <p>
        Esta herramienta se divide en varias funcionalidades y secciones. Por
        este motivo estos manuales dividiran la información en tres secciones:
      </p>
      <ul>
        <li>
          <strong>Custodia de pagarés:</strong> Esto hace referencia a la
          navegación de los pagarés, se explica como encontrar, revisar y
          descargar pagarés, así como entender la interpretación de la
          información presentada en cada pagaré. También como descargar pagarés,
          certificados y documentos asociados.
        </li>
        <li>
          <strong>Administración de pagarés:</strong> Esto hace referencia a la
          gestión de los pagarés, se explica como crear, anular, diligenciar,
          endosar, cancelar y administrar pagarés en general, esta es una guía
          más directa de como realizar acciones sobre el pagaré.
        </li>
        <li>
          <strong>Creación de pagarés:</strong> Si se tiene configurado un
          pagaré que se pueda crear desde el sistema sin la necesidad de un
          flujo. Esta guía le ayudará a entender cada una de las subsecciones en
          la creación del pagaré manual, asi como las acciones que se deben
          realizar en cada una de ellas.
        </li>
      </ul>

      <h3
        style={{
          fontWeight: "bold",
          fontSize: "36px",
        }}
      >
        Custodia de pagarés
      </h3>
      <p>
        Este manual permite entender como navegar en la sección de pagarés e
        interpretar la información que se muestra en cada pagaré. Si se requiere
        información sobre como realizar acciones sobre el pagaré, puede
        consultar el manual de administración de pagarés más adelante.
      </p>
      <object
        data="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20PAGAR%C3%89S%20V2.pdf"
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <p>
          Descarga alternativa:{" "}
          <a href="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20PAGAR%C3%89S%20V2.pdf">
            Si no se ve puede dar click aquí para descargar el PDF
          </a>
        </p>
      </object>
      <h3
        style={{
          fontWeight: "bold",
          fontSize: "36px",
        }}
      >
        Administración de pagarés
      </h3>
      <p>
        Este manual permite entender como crear, anular, diligenciar, endosar,
        cancelar y realizar acciones sobre los pagarés, estas funcionalidades
        son avanzadas y solo deben ser realizadas por personas autorizadas,
        debido a que cada proceso tiene implicaciones legales y financieras.
      </p>
      <object
        data="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20PAGAR%C3%89S%20-%20ADMINISTRACI%C3%93N%20V2.pdf"
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <p>
          Descarga alternativa:{" "}
          <a href="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20PAGAR%C3%89S%20-%20ADMINISTRACI%C3%93N%20V2.pdf">
            Si no se ve puede dar click aquí para descargar el PDF
          </a>
        </p>
      </object>
      <h3
        style={{
          fontWeight: "bold",
          fontSize: "36px",
        }}
      >
        Creación manual de pagarés
      </h3>
      <p>
        Este manual permite entender como utilizar la funcionalidad de creación
        de pagarés sin necesidad de un flujo. Esto solo estará activo si se
        tiene configurado un pagaré que se pueda crear desde el sistema sin la
        necesidad de un flujo, además de necesitar los permisos adecuados. NO
        utilice esta guía para crear pagarés no configurados para este
        propósito, ya que pueden causar errores en la creación de pagarés.
      </p>
      <object
        data="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20PAGAR%C3%89S%20-%20CREACI%C3%93N%20DE%20PAGAR%C3%89%20MANUAL.pdf"
        type="application/pdf"
        width="100%"
        height="100%"
      >
        <p>
          Descarga alternativa:{" "}
          <a href="https://cdn.anteia.co/back-office/manuales/MANUAL%20DE%20USUARIO%20PAGAR%C3%89S%20-%20CREACI%C3%93N%20DE%20PAGAR%C3%89%20MANUAL.pdf">
            Si no se ve puede dar click aquí para descargar el PDF
          </a>
        </p>
      </object>
    </div>
  );
};
